












import { defineComponent } from '@vue/composition-api';

const name = 'ttam-library-tips';

export default defineComponent({
  name,

  props: {
    isNativePullPost: { type: Boolean, default: false },
  },
});
